import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Router} from '@angular/router';
import {map, tap} from 'rxjs/operators';
import {retrieveFirebaseJWTTokenSuccess, setFirebaseCredentials} from '@app/firebase-status/firebase-status.actions';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {AuthService} from '@app/services/auth/auth.service';
import {cloneDeep} from 'lodash-es';

@Injectable()
export class FirebaseStatusEffects {
  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    public router: Router,
    public angularFireAuth: AngularFireAuth,
    private authService: AuthService,
  ) {
  }

  //
  // Login réel à la BD firebase
  //
  retrieveFirebaseJWTTokenSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(retrieveFirebaseJWTTokenSuccess),
      map((action) => action),
      tap((payload) => {

        // console.log('[Firebase flow] [1/3] tentative connection avec token', payload.token);
        // console.log('[Firebase flow] [1/3] tentative connection avec token');

        this.angularFireAuth.signInWithCustomToken(cloneDeep(payload.token))
          .then((userCredential) => {
            // console.log('[Firebase flow] [2/3] Is signedWith FBase!', userCredential.user);
            this.store.dispatch(setFirebaseCredentials({credentials: 'RIEN DU TOUT'}));
            this.authService.startListeningUser();
          })
          .catch((error) => {
            console.log('[Firebase flow] [2/x] FAILED to sign with FBase!', error);
            console.log(error);
          });
      }),
    ), {dispatch: false}
  );

}
